export default {
    itemInfo: {
        itemIdTemplate: 'id',
        itemLabelKey: 'description',
    },
    pageTitle: 'Notifications',
    siteMapKey: 'swc.settings.notifications',
    onlineHelpId: 1000,
    sectionsLabel: 'Notifications',
    selectOptionKeys: [
        'dataWarehouseAirline',
        'dataWarehouseStation',
        'dataWarehouseFlightMarketCode',
        'dataWarehouseReportingCategory',
        'dataWarehouseAircraftBodyType',
        'slaType',
        'notificationInstanceType',
    ],
    sectionListCollapsible: true,
};
